'use client';
import { FC } from 'react';

import { Grid } from '@gds/Grid/Grid';
import { Typography } from '@gds/Typography/Typography';

import { isEmptyRichText } from '@kentico/Utils/IsEmptyRichText';

import { RichText } from '@page-builder/Components/RichText/RichText';

import FloatingCta from '../FloatingCta/FloatingCta';

import styles from './NumericalTable.module.css';

type Props = {
  cmsData: any;
};

const NumericalTable: FC<Props> = ({ cmsData }) => {
  const { elements } = cmsData;
  const {
    num_table_columns: columns,
    num_table_description: description,
    num_table_floatingcta: cta,
    num_table_headline: heading,
  } = elements;

  const hasColumns = columns.value.length > 0;
  const hasCta = cta.linkedItems.length > 0;

  return (
    <div className={`blogCmpnt ${styles.tableComponent}`}>
      <Grid.Container className={styles.container}>
        <Typography variant="h2" className={styles.header}>
          {heading.value}
        </Typography>

        {!isEmptyRichText(description.value) && (
          <RichText richText={description.value} className={styles.description} />
        )}

        {hasColumns && (
          <div className={styles.table}>
            {columns.linkedItems.map((column: any) => {
              const { elements } = column;
              const { num_table_column_heading: title, num_table_column_values_list: list } =
                elements;

              return (
                <div key={column.system.id} className={styles.column}>
                  {title.value && (
                    <Typography Component="h3" variant="h5" className={styles.columnTitle}>
                      {title.value}
                    </Typography>
                  )}
                  {list.value && <RichText richText={list.value} />}
                </div>
              );
            })}
          </div>
        )}
        {hasCta &&
          cta.linkedItems.map((linkedItem: any) => (
            <FloatingCta key={linkedItem.system.id} cmsData={linkedItem} />
          ))}
      </Grid.Container>
    </div>
  );
};

export default NumericalTable;
